export type SupportedLocale = (typeof supportedLocales)[number];

const supportedLocales = ['fr', 'ar', 'en'] as const;
const localeStorageKey = 'locale';
const fallbackLocale: SupportedLocale = 'fr';

export function isSupportedLocale(locale: string | null | undefined): locale is SupportedLocale {
  return !!locale && (supportedLocales as ReadonlyArray<string>).includes(locale);
}

export function getLangFromQueryParam(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get(localeStorageKey);
}

export function getLangFromLocalStorage(): string | null {
  return localStorage.getItem(localeStorageKey);
}

export function setLangToLocalStorage(locale: SupportedLocale): void {
  localStorage.setItem(localeStorageKey, locale);
}

export function getLangFromBrowser(): string {
  return navigator.language.split('-')[0];
}

export function setDocumentDirection(locale: SupportedLocale): void {
  document.documentElement.setAttribute('dir', locale === 'ar' ? 'rtl' : 'ltr');
}

export function resolveLocale(): SupportedLocale {
  const languageFromQueryParam = getLangFromQueryParam();

  if (isSupportedLocale(languageFromQueryParam)) {
    setLangToLocalStorage(languageFromQueryParam);
    return languageFromQueryParam;
  }

  const languageFromLocalStorage = getLangFromLocalStorage();
  if (isSupportedLocale(languageFromLocalStorage)) {
    return languageFromLocalStorage;
  }

  const languageFromBrowser = getLangFromBrowser();
  if (isSupportedLocale(languageFromBrowser)) {
    setLangToLocalStorage(languageFromBrowser);
    return languageFromBrowser;
  }

  setLangToLocalStorage(fallbackLocale);
  return fallbackLocale;
}
